import { SearchExpression } from '../../model/search/advanced/SearchExpression';
import { Preferences } from '../../model/user/Preferences';
import { PreferenceService } from '../../services/user/PreferenceService';

import { Factory } from '../../services/Factory';

import IDirective = angular.IDirective;

interface IAddTagScope extends angular.IScope {
  project: any,
  collection: any | Array<any>,
  resource: any | Array<any>,
  filter,
  hideTagRelated: boolean,
  searchExpression: SearchExpression,
  columnFilters: SearchExpression,
  saving: boolean;
  totalResourceCount: number;
  selectAll: boolean
}

interface IAddTagAttributes extends angular.IAttributes {
}

export class AddTag implements IDirective {
  public restrict: string = "E";
  public link: (scope: IAddTagScope, element: angular.IAugmentedJQuery, attrs: IAddTagAttributes) => void;
  public templateUrl: string;
  public scope = {
    project: "=",
    collection: "=",
    resource: "=",
    chatMessageId: "=",
    filter: "=",
    hideTagRelated: "@",
    searchExpression: "=",
    columnFilters: "=",
    totalResourceCount: "=",
    selectAll: "="
  };
  private $sce: angular.ISCEService;
  private $uibModal;
  private $filter: angular.IFilterService;

  constructor($rootScope, $sce: angular.ISCEService, $filter: angular.IFilterService, $uibModal, preferenceService: app.services.user.PreferenceService, tagService: app.services.tagging.TagService, notificationService: app.services.INotificationService) {
    this.$sce = $sce;
    this.$uibModal = $uibModal;
    this.templateUrl = "partials/tagging/add_tag.html";
    this.link = (scope: IAddTagScope, element: angular.IAugmentedJQuery, attrs: IAddTagAttributes) => {
      this.$filter = $filter;
      scope.tag = null;
      scope.tagRelated = preferenceService.Get(Preferences.TAG_RELATED);

      $rootScope.$on(PreferenceService.GetEventForPreference(Preferences.TAG_RELATED), (evt, val) => scope.tagRelated = val);

      scope.getSuggestions = (val) => {
        let categoryBitmask = 7;

        if (scope.resource || scope.searchExpression || scope.filter) {
          categoryBitmask = 4; // only project
        }

        return tagService.GetSuggestions(scope.project.id, val, categoryBitmask).then(response => response.data);
      };

      scope.addTag = () => {
        // Add Tag from Resource full-view
        if (scope.project && scope.collection && scope.resource && !Array.isArray(scope.resource)) {
          scope.saving = true;

          if (scope.chatMessageId) {
            tagService.TagConversation(scope.project, scope.collection as any, scope.resource, scope.chatMessageId, scope.tagName).then(tag => {
              scope.tag = null;
              scope.saving = false;

              notificationService.addSuccess({
                title: "Tagging Started",
                description: `Adding ${scope.tagName} to conversation.  We will notify you when it completes.`,
                timeout: 2500
              });
            });

            scope.saving = false;
          } else {
            tagService.TagResource(scope.project, scope.collection as ICollection, scope.resource, scope.tagName, scope.$parent.tagFormSwitch.tagRelated, tag => {
              scope.tag = null;
              scope.saving = false;
            });
          }
          // User resource selections
        } else if (scope.resource && Array.isArray(scope.resource) && scope.resource.length > 0) {
          tagService.TagResources(scope.project, scope.resource, scope.tagName, scope.tagRelated, tag => {
            scope.tag = null;
            scope.saving = false;

            notificationService.addSuccess({
              title: "Tag Added",
              description: `${scope.tagName} to selections`,
              timeout: 2500
            });
          });
          // Tag Explorer
        } else if (scope.project && scope.collection && scope.filter) {
          const execute = () => tagService.TagCollections(scope.project, scope.collection as Array<ICollection>, scope.filter, scope.columnFilters, scope.tagName, scope.tagRelated, tag => {
            scope.tag = null;
            scope.saving = false;

            notificationService.addSuccess({
              title: "Tag Added",
              description: `${tag.name} to results`,
              timeout: 2500
            });
          });

          this.ConfirmBulkTag(scope, execute, true);
          // Search collection
        } else if (scope.project && scope.collection && scope.searchExpression) {
          const execute = () => {
            tagService.TagCollectionSearch(scope.project, scope.collection as ICollection, scope.searchExpression, scope.columnFilters, scope.tagName, scope.tagRelated, tag => {
              scope.tag = null;
              scope.saving = false;

              notificationService.addSuccess({
                title: "Tagging Started",
                description: `${tag.name} to Collection search results.  We will notify you when it completes.`,
                timeout: 2500
              });
            });
          };

          this.ConfirmBulkTag(scope, execute);
          // Search project
        } else if (scope.project && scope.searchExpression) {
          const execute = () => {
            tagService.TagProjectSearch(scope.project, scope.searchExpression, scope.columnFilters, scope.tagName, scope.tagRelated, tag => {
              scope.tag = null;
              scope.saving = false;

              notificationService.addSuccess({
                title: "Tagging Started",
                description: `${tag.name} to Project search results.  We will notify you when it completes.`,
                timeout: 2500
              });
            });
          };

          this.ConfirmBulkTag(scope, execute);
        }
      };

      scope.$watch("tag", () => {
        if (_.isObject(scope.tag)) {
          scope.tagName = scope.tag.name;
        } else if (_.isString(scope.tag)) {
          scope.tagName = scope.tag;
        }
      });

      scope.$watch("tagRelated", val => {
        preferenceService.Set(Preferences.TAG_RELATED, val);
        $rootScope.$broadcast(PreferenceService.GetEventForPreference(Preferences.TAG_RELATED), val);
      });
    }
  }

  private ConfirmBulkTag(scope: IAddTagScope, execute: Function, isTagExplorer = false) {
    let message = `
            <div class="row">
              <div class="col-sm-12">
                Are you sure you want to apply this bulk tag affecting <span class="label label-warning">${this.$filter("number")(scope.totalResourceCount)}</span> resources? (<i>Count excludes related items if checked</i>)
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                &nbsp;
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3">
                Tag Related:
              </div>
              <div class="col-sm-9">
                <span class="label label-default">${scope.tagRelated}</span>
              </div>
            </div>
          `;

    if (isTagExplorer) {
      message += `
            <div class="row">
              <div class="col-sm-3">Collections:</div>
              <div class="col-sm-9">${(scope.collection as Array<ICollection>).map(c => `<span class="label label-default">${c.name}</span>`).join(" ")}</div>
            </div>`;
    }

    const modalInstance = this.$uibModal.open({
      backdrop: true,
      keyboard: true,
      backdropClick: true,
      templateUrl: 'partials/dialog_confirm.html',
      controller: 'ConfirmModalCtrl',
      scope: scope,
      resolve: {
        title: () => "Bulk Tag Confirmation",
        message: () => this.$sce.getTrustedHtml(message)
      }
    });

    modalInstance.result.then(val => {
      if (val == "ok") {
        scope.saving = true;
        execute();
      }
    });
  }
}

frontendApp.directive("iioAddTag", ["$rootScope", "$sce", "$filter", "$uibModal", "PreferenceService", "TagService", "NotificationService", Factory.Create(AddTag)]);
